import { render, staticRenderFns } from "./inputConfig.vue?vue&type=template&id=ce2a53f4&scoped=true"
import script from "./inputConfig.vue?vue&type=script&lang=js"
export * from "./inputConfig.vue?vue&type=script&lang=js"
import style0 from "./inputConfig.vue?vue&type=style&index=0&id=ce2a53f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2a53f4",
  null
  
)

export default component.exports